import {useLayoutAuthorLogin} from '../../../../stores/layout-selectors'
import type {ReviewSummary} from '../../../../page-data/payloads/review-summaries'
import {ReviewSummaryItem} from '../../../comments/ReviewSummaryItem'

export function ReviewContent({reviewSummary}: {reviewSummary: ReviewSummary}) {
  const pullRequestAuthorLogin = useLayoutAuthorLogin()

  // TODO - we eventually will probably want to show the related review threads - out of scope for the moment

  return (
    <ReviewSummaryItem
      reviewSummary={reviewSummary}
      pullRequestAuthorLogin={pullRequestAuthorLogin}
      canReact
      className="border-0"
    />
  )
}
